import { useNavigate, useParams } from "react-router-dom";

import Grid from "@Components/Grid";
import Button from "@Components/Button";
import { useGetDeal } from "@Hooks/useDeals";
import { formatDate } from "@Utils/functions";
import BackButton from "@Components/BackButton";
import TicketsChat from "@Pages/Tickets/TicketsChat";
import LoadingFullScreen from "@Components/Loading/LoadingFullScreen";

import UCC from "./UCC";
import Applicant from "./Applicants";
import Collateral from "./Collateral";
import Dealership from "./Dealership";
import FinancialInfo from "./FinancialInfo";
import styles from "./Application.module.scss";
import TradeIn from "./TradeIn";
import TitleInfo from "../TitleInfo/TitleInfo";

const Deal = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const { data: deal, isLoading, error } = useGetDeal(id as string);

  if (isLoading) return <LoadingFullScreen />;
  if (error) return <>{error.message}</>;

  const uccFees = (deal?.data?.info?.taxesAndFees?.fundingFees ?? []).filter(
    (x) => x.type === "UCC" && x?.document?.url
  );
  return deal ? (
    <Grid container xs={12} spacing={1} className={styles.container}>
      <Grid xs={1.5}>
        <BackButton />
      </Grid>
      <Grid container xs={12}>
        <Grid xs={9}>
          <h2 className={styles.title}> Loan information</h2>
          <p className={styles.date}>
            {`Contract date:
        ${formatDate(deal.data.info.dealDates?.contractDate, "long")}`}
          </p>
        </Grid>
        {deal?.data?.lenderTickets?.length ? (
          <Grid xs={3}>
            <Button
              variant="blue"
              onClick={() => {
                navigate(`/tickets/${deal?.data?.lenderTickets?.[0]?._id}`);
              }}
            >
              Open Ticket
            </Button>
          </Grid>
        ) : (
          <Grid xs={3}>
            <TicketsChat deal={deal} />
          </Grid>
        )}
      </Grid>
      <Grid xs={8}>
        <TitleInfo deal={deal} />
      </Grid>
      <Grid xs={8}>
        <Applicant type="applicant" deal={deal} />
      </Grid>
      <Grid xs={4}>
        <Applicant type="coApplicant" deal={deal} />
      </Grid>
      <Grid xs={8}>
        <Collateral
          collateral={deal?.data?.info?.vehicle}
          type={deal?.data?.info?.type}
        />
      </Grid>
      <Grid xs={8}>
        <TradeIn tradeIn={deal?.data?.info?.price?.trade?.[0]} />
      </Grid>
      <Grid xs={8}>
        <Dealership dealership={deal?.data?.dealership} />
      </Grid>
      {uccFees.length ? (
        <Grid xs={8}>
          <UCC uccFees={uccFees} />
        </Grid>
      ) : null}
      <Grid xs={8}>
        <FinancialInfo deal={deal} />
      </Grid>
    </Grid>
  ) : null;
};

export default Deal;
